// Blog-Cockpit (frontend/src/pages/BlogDashboard.tsx + BlogTopicDetail.tsx) —
// deutsche QUELLE. Der Such-Intent-Backlog, das Claims-Archiv und die
// Trend-Inbox. Doktrin: docs/blog-engine-konzept.md.
//
// benefit_area-Namen („Feuchtigkeit & Barriere") sind DB-Domänendaten und werden
// NICHT übersetzt (wie Dataset-Namen) — sie erscheinen roh in beiden Sprachen.
export const blog = {
  title: "Blog-Cockpit",
  reload: "Neu laden",
  loading: "Blog-Cockpit wird geladen …",

  stats: {
    topics: "Topics",
    published: "publiziert",
    blocked: "gesperrt",
    trendsToWrite: "Trends zu schreiben",
  },

  tabs: {
    backlog: "Artikel",
    claims: "Claims",
    moa: "MoA",
    trends: "Trend-Inbox",
    evidence: "Evidenz-Review",
  },

  // blog_topic.status
  status: {
    backlog: "Backlog",
    planned: "Geplant",
    generating: "In Arbeit",
    draft: "Entwurf",
    review: "Review",
    approved: "Freigegeben",
    published: "Publiziert",
  },

  topicClass: {
    basis: "Basis",
    kuer: "Kür",
  },

  backlog: {
    intro: "Such-Intent-Topics je Rubrik. Basis = aus der Evidenz, Kür = aus einem Trend.",
    empty: "Kein Backlog vorhanden",
    emptyHint: "Sobald der Such-Intent-Backlog (blog_topic) befüllt ist, erscheinen hier die Topics je Rubrik.",
    topicsCount: (n: number) => `${n} ${n === 1 ? "Topic" : "Topics"}`,
  },

  card: {
    eviClaims: (n: number) => `${n} ${n === 1 ? "Beleg" : "Belege"}`,
    noEvidence: "keine Evidenz",
    blocked: "gesperrt",
    keyword: "Keyword",
    duplicate: "Dublette",
    duplicateHint: "Merge-Vorschlag (N10): gleicher Claim-Pool oder gleicher Such-Intent wie ein anderes Topic.",
  },

  articleType: {
    ingredient_deep_dive: "Deep-Dive",
    mechanism_explainer: "Mechanismus",
    formulation_guide: "Formulierungs-Guide",
    claim_benefit_guide: "Claim-Guide",
    comparison: "Vergleich",
    study_digest: "Studien-Digest",
    method_explainer: "Methode",
    regulatory_certification: "Regulatorik",
    trend_market: "Trend",
    problem_skin_type: "Problem / Hauttyp",
  },

  topic: {
    back: "Zurück zum Cockpit",
    eyebrow: "Such-Intent-Topic",
    evidenceCore: "Evidenz-Kern",
    evidenceHint: "Die signifikanz-gegateten evi-Claims, die dieses Topic tragen.",
    certificates: "Zertifikate",
    certificatesHint: "Als Tags erwähnbar, wo sie zum Thema passen — nie das Artikel-Thema.",
    pipeline: "Pipeline",
    generate: "Artikel generieren",
    generating: "Artikel wird geschrieben … (~15–40 s)",
    openArticle: "Artikel öffnen",
    regenerate: "Neu generieren",
    noArticleYet: "Noch kein Artikel generiert.",
    notFound: "Topic nicht gefunden",
    notFoundHint: "Dieses Topic existiert nicht (mehr).",
    generateFailed: "Generierung fehlgeschlagen",
    fromTrend: "aus Trend",
    blockedReason: "Blocker",
    noEvidenceWarn: "Ohne evi-Claim kein Artikel — dieses Topic hat keine Evidenz verknüpft.",
  },

  claims: {
    intro: "Nur freigegebene Claims — die am Evidence-Board freigegebenen Karten. Drop- und Safety-Karten erscheinen hier nie.",
    all: "Alle",
    fullReview: "Voll-Review",
    presentation: "Präsentation",
    empty: "Keine Claims vorhanden",
    emptyHint: "Gib am Evidence-Board eine Karte frei, damit sie hier erscheint.",
    count: (n: number) => `${n}`,
    caveat: "Vorbehalt",
  },

  moa: {
    intro: "Die Mechanismus-Ebene — wie das Molekül wirkt, je Rubrik. Fußnoten und Provenance stehen auf jeder Karte.",
    all: "Alle",
    empty: "Keine MoA-Karten vorhanden",
    emptyHint: "Sobald die MoA-Karten befüllt sind, erscheint hier die Mechanismus-Galerie.",
  },

  // Evidence-Board (Spec Evidenz-Board v2 §4b) — Galerie der 46 Claim-Kandidaten.
  // Release-Gate: use/use_framed standardmäßig freigegeben (Expertin kann zurückziehen),
  // drop/safety immer intern. Wirkbereiche kommen übersetzt vom Server (effect_area_en).
  evidence: {
    intro:
      "Eine Karte je Claim-Kandidat: die vorgeschlagene Studien-Scheibe als Grafik plus ein Satz. Freigegebene Karten dürfen für Claims genutzt werden; interne nur für die Atlas-Übersicht.",
    empty: "Keine Kandidaten vorhanden",
    emptyHint: "Sobald evi_claim_candidate befüllt ist (python -m app.scripts.load_evi_claim_candidates), erscheinen hier die Karten.",
    emptyFiltered: "Keine Karten für diese Filter.",
    count: (shown: number, total: number) =>
      `${shown} von ${total} Karten${shown !== total ? " (gefiltert)" : ""}`,
    filterRelease: "Status",
    filterClass: "Klasse",
    filterArea: "Wirkbereich",
    reset: "Zurücksetzen",
    groups: { released: "Freigegeben", internal: "Intern" },
    groupHint: {
      released: "Use und Use (framed) — dürfen für Claims genutzt werden.",
      internal: "Safety-Aussagen, Drops und zurückgezogene Karten — nicht für Claims.",
    },
    cls: { use: "Use", use_framed: "Use (framed)", use_qualitative: "Use (qualitativ)", safety: "Safety-Aussage", drop: "Drop" },
    release: { released: "Freigegeben", internal: "Intern" },
    internalMarker: "Intern — nicht für Claims",
    withdrawn: "von der Expertin zurückgezogen",
    sourceNotNameable: "Quelle nicht nennbar",
    toggleOn: "Für Claims freigegeben",
    toggleOff: "Zurückgezogen (intern)",
    locked: "Per Regel intern — nicht freigebbar",
    releasedToast: "Karte freigegeben",
    withdrawnToast: "Karte zurückgezogen — jetzt intern",
    saveFailed: "Speichern fehlgeschlagen",
    lastBy: (who: string, when: string | null) =>
      `${who}${when ? ` · ${new Date(when).toLocaleDateString("de-DE")}` : ""}`,
    comment: "Kommentar",
    commentPlaceholder: "Kommentar (optional)",
    saveComment: "Kommentar speichern",
    commentSaved: "Kommentar gespeichert",
    svgFailed: "Karte konnte nicht geladen werden",
    proof: "Beleg",
    shownOmitted: (shown: number, omitted: number) => `${shown} gezeigt · ${omitted} weggelassen`,
    source: "Quelle",
    design: "Design",
    shownRows: (n: number) => `Gezeigte Zeilen (${n})`,
    omittedRows: (n: number) => `Weggelassene Zeilen mit Grund (${n})`,
    loading: "Lädt …",
    loadFailed: "Weggelassene Zeilen konnten nicht geladen werden",
    keyNumber: "Kennzahl (berechnet)",
    roundedDown: "abgerundet",
    caveats: "Hinweise & Vorbehalte",
    caveatsOriginal: "Expertinnen-Notiz (Originalsprache)",
    figures: "Studien-Abbildungen",
    downloads: "Downloads",
    cardSvg: "Karte SVG",
    cardPng: "Karte PNG",
    chartSvg: "Grafik SVG",
    chartPng: "Grafik PNG",
  },

  trends: {
    intro: "Vom Trend-Radar erkannte Themen. Ein Schreiben-Klick macht daraus ein Kür-Topic im Backlog.",
    refresh: "Radar aktualisieren",
    refreshing: "Radar läuft …",
    refreshDone: (n: number) => `Radar fertig — ${n} ${n === 1 ? "Trend" : "Trends"}`,
    refreshFailed: "Radar-Lauf fehlgeschlagen",
    filter: {
      all: "Alle",
      watch: "Beobachten",
      write: "Schreiben",
      dismissed: "Verworfen",
    },
    write: "Schreiben",
    watch: "Beobachten",
    dismiss: "Verwerfen",
    open: "Zum Kür-Topic",
    writeGateHint: "Kein evi-Backing in der Rubrik — kein Full-Article möglich.",
    notMapped: "keiner Rubrik zugeordnet",
    groundable: "evi-belegt",
    momentum: "Momentum",
    sources: "Quellen",
    empty: "Keine Trends",
    emptyHint: "Starte einen Radar-Lauf, um Trend-Themen zu erkennen.",
    statusUpdated: "Status aktualisiert",
    writePromoted: "Als Kür-Topic im Backlog angelegt",
    statusFailed: "Status konnte nicht gesetzt werden",
  },

  seo: {
    title: "SEO & Veröffentlichung",
    edit: "Bearbeiten",
    save: "Speichern",
    cancel: "Abbrechen",
    saved: "Gespeichert.",
    saveFailed: "Speichern fehlgeschlagen",
    subtitle: "Untertitel",
    slug: "Slug",
    meta: "Meta-Beschreibung",
    chars: (n: number) => `${n} Zeichen`,
    primaryKeyword: "Primär-Keyword",
    byline: "Autor",
    reviewedBy: (r: string) => `geprüft von ${r}`,
    cta: "Abschluss-CTA",
    ctaMissing: "fehlt",
    lintNumbers: (n: number) => `${n} Zahl(en) nicht in den Writer-Inputs`,
    lintAnchors: (n: number) => `${n} Topic-Anker nicht released, nicht verwendet`,
    lintOk: "Alle Zahlen durch Writer-Inputs belegt",
    absent: "(nicht gesetzt)",
  },

  cert: {
    certified: "Zertifiziert",
    selfDeclared: "Selbst-deklariert",
    dataStatement: "Daten/Statement",
    validUntil: (d: string) => `gültig bis ${d}`,
  },
};
